const IMPERSONATOR_CLAIM = 'impersonatorEmail';

export const hasImpersonationToken = (): boolean => {
    const token = localStorage.getItem('token');

    if (!token) {
        return false;
    }

    try {
        const payload = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
        const claims = JSON.parse(atob(payload));

        return !!claims[IMPERSONATOR_CLAIM];
    }
    catch {
        return false;
    }
}
